import AdminSidebar from "../../layouts/admin/AdminSidebar";
import Header from "../../layouts/admin/Header";

const AdminLayout = ({ children }) => {
  return (
    <div>

      {/* SIDEBAR — fixed, apni jagah khud handle karta hai */}
      <div className="d-none d-lg-block">
        <AdminSidebar />
      </div>

      {/* MAIN CONTENT */}
      <div className="admin-main-content">
        <Header />
        {children}
      </div>

    </div>
  );
};

export default AdminLayout;